export const buttonOn = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 0.75,
    fontWeight: 700,
    color: '#1a0a00',
    letterSpacing: '0.01em',
    background: 'linear-gradient(90deg, #FFDF10 0%, #FF9E00 50%, #FF4D00 100%)',
    borderRadius: '999px',
    px: '1.1rem',
    py: '0.5625rem',   // fix 3 — 52px → 50px (was 0.6rem)
    border: 'none',
    cursor: 'pointer',
    boxShadow: '0 12px 28px -10px rgba(255,158,0,0.55)',
    transition: 'transform 0.18s ease, filter 0.25s ease',
    '&:hover': { transform: 'translateY(-1px)', filter: 'saturate(1.08)' },
};

export const countBadge = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '1.4rem',
    height: '1.4rem',
    px: '0.4rem',
    borderRadius: '999px',
    background: 'rgba(26,10,0,0.18)',
    fontSize: '0.72rem',
    fontWeight: 700,
    color: '#1a0a00',
};

export const flameIconOn = {
    fontSize: 16,
    color: '#1a0a00',
};

export const flameIconOff = {
    fontSize: 16,
    color: 'var(--ecal-orange)',
    opacity: 0.8,
};
